export const environment = {
  production: false,
 
  // apiUrl: 'https://salesapi.studiflats.com/api', 
  apiUrl: ' https://sales.studiflats-it.com/api',
  
  chat:"https://signals.studiflats.com",
  
  firebase: {
    apiKey: 'AIzaSyDgIjUL-Kw0nadAqbZiy9_o0NSYPo_C3vg',

    authDomain: 'vivas-apratments.firebaseapp.com',

    projectId: 'vivas-apratments',

    storageBucket: 'vivas-apratments.appspot.com',

    messagingSenderId: '727951335686',

    appId: '1:727951335686:web:3daea30f480efa1b2afe87',

    measurementId: 'G-16FPLN8HL7',
    vapidKey:
      'BAqbUMZwLPkfTwA-msaRypNemVhLPmACcNIXXVBe1cfmMZRgiRkNAlRf6LKsrM6RLzMOcOPfPgcdDAeyQ2fm1SQ',
  },
};
